import { Button, Image, Progress } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { VerticalDivider } from '@hero/atoms';
import { DEVICE } from '@hero/constants';

import { TableProducts } from '../TableProducts';

const Header = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  ${Button.S.Button} {
    font-size: 14px;
  }

  ${DEVICE.mobile.max} {
    ${VerticalDivider} {
      display: none;
    }
  }
`;

const Recognition = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const RecognitionName = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
`;

const ExpandedContent = styled.div`
  background-color: var(--color-bg-subtle);
  border-top: 1px solid var(--color-border-default);
  padding: 16px 24px;
`;

const ExpandedGrid = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
`;

const ExpandedGridItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ExpandedSection = styled.div`
  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

const ExpandedSectionTitle = styled.div`
  margin-bottom: 16px;
`;

const ExpandedRowWrapper = styled.div`
  background-color: var(--color-bg-weak);
  margin-left: 4rem;
  margin-right: 30px;
  padding: var(--size-24);
`;

const ExpandedRowInnerWrapper = styled.div`
  display: flex;
`;

const ExpandedRowBottomWrapper = styled.div`
  display: flex;
  gap: var(--size-16);
  justify-content: flex-end;
`;

const SummaryWrapper = styled.div`
  width: 40%;
`;

const SummaryItem = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: var(--size-16);
  white-space: nowrap;
`;

const SummaryItemRight = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  min-width: 200px;

  ${Progress.S.Progress} {
    width: 100%;
  }

  ${TableProducts.S.TableProducts} {
    justify-content: flex-end;

    ${Image.S.Image},button {
      border-radius: 100%;
    }
  }
`;

const ChartWrapper = styled.div`
  width: 70%;
`;

export {
  ChartWrapper,
  ExpandedContent,
  ExpandedGrid,
  ExpandedGridItem,
  ExpandedRowBottomWrapper,
  ExpandedRowInnerWrapper,
  ExpandedRowWrapper,
  ExpandedSection,
  ExpandedSectionTitle,
  Header,
  Recognition,
  RecognitionName,
  SummaryItem,
  SummaryItemRight,
  SummaryWrapper
};
